import * as React from 'react';

import SVGIcon from 'components/svg-icon/SVGIcon';

import { CHANNEL_TYPE_TIKTOK, CHANNEL_TYPE_YOUTUBE } from 'utils/channels';

import './tile-standard-carousel-item-overlay.scss';

type Props = {
  type: string
};

const TileStandardCarouselItemOverlay: React.FunctionComponent<Props> = ({ type }: Props) => (
  (type === CHANNEL_TYPE_YOUTUBE || type === CHANNEL_TYPE_TIKTOK)
    ? (
      <div className="tile-standard-carousel-item-overlay">
        <SVGIcon
          name="play-button"
          width={40}
          height={40}
        />
      </div>
    )
    : null
);

export default TileStandardCarouselItemOverlay;
